import React,{ FC } from 'react'
import PropTypes from 'prop-types'
import { formatNumberWithCommas } from '../../../../globalUtils/globalHooks'
import { AlarmPulseLoader } from '../../../../globalUtils/globalExports'
import './VersionStatusCards.css'
import { IconWithTooltip } from '../../../../globalUtils/globalIcons'

export const CardType = {
  statusContainerClassName: PropTypes.string,
  cardId: PropTypes.string.isRequired,
  count: PropTypes.number,
  footerText: PropTypes.string,
  footerSubText: PropTypes.string,
  headerText: PropTypes.string.isRequired,
  selectedCard: PropTypes.string,
  onCardClick: PropTypes.func,
  bgColor: PropTypes.string,
  icon: PropTypes.string,
  loader: PropTypes.bool,
  headerTooltipText: PropTypes.string,
}

export const versionStatsCardMapper = {
  UPDATED: {
    title: 'Updated',
    borderColor: '#13B18F',
    color:'#0C876D'
  },
  PENDING: {
    title: 'Pending',
    borderColor:'#F9C447',
    color: '#AF7C00',
  },
  FAILED: {
    title: 'Failed',
    borderColor:'#FF5F5F',
    color: '#CF4141',
  },
}


export type CardPropTypes = PropTypes.InferProps<typeof CardType>



export const VersionStatsCards: FC<CardPropTypes> = (props) => {
  const { statusContainerClassName, cardId, count, headerText, onCardClick, selectedCard, loader,headerTooltipText } = props

  return (
    <>
      <div key={cardId + count} id={cardId} className={'version__status__summary-card ' + statusContainerClassName} style={{ borderTop: `4px solid ${versionStatsCardMapper[headerText]?.borderColor}`, borderColor: (selectedCard === headerText) ? versionStatsCardMapper[headerText]?.borderColor : '' }} onClick={(e) => { e?.stopPropagation(); onCardClick?.(props) }}>

        <div className='version__status__summary-card-border' style={{
          backgroundColor: versionStatsCardMapper[headerText]?.borderColor
        }}></div>
        <div className='version__status__summary-card-header' style={{ color: versionStatsCardMapper[headerText]?.color,display:'flex',gap:'4px' }}>
          {versionStatsCardMapper[headerText]?.title}
          <IconWithTooltip iconClassName="rms_info_icon-black" toolTipText={headerTooltipText ?? ''} containerClassName={statusContainerClassName + ' version_stats_cards-header-tooltip'}  />
        </div>
        {
          loader ? <div className='version__status__summary-card-count'><AlarmPulseLoader showLoader={loader ?? false} /></div> :
            <div className='version__status__summary-card-count'>{formatNumberWithCommas(count)}</div>
        }
      </div>
    </>

  )
}